import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/marketing-voucher";

export const getAllMarketingVoucher = () => axios.get(API_PATH + "/get-all");

export const pagingMarketingVoucher = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getMarketingVoucherById = (id) => axios.get(API_PATH + "/get-by-id/" + id);

export const saveMarketingVoucher = obj => axios.post(API_PATH + '/save', obj);

export const deleteMarketingVoucher = id => axios.delete(API_PATH + '/mark-delete/' + id)

export const pagingMarketingVoucherUsed = (searchObject) => axios.post(API_PATH + "/search-by-page-used", searchObject);
